export default {"src":"/_next/static/media/main_logo_white.c89b0052.svg","height":781,"width":3685,"blurWidth":0,"blurHeight":0};